module.exports = __webpack_public_path__ + "static/img/会面详情（已取消、已结束）.4254be2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/会面详情（已取消、已结束）.png
// module id = YVGc
// module chunks = 1